<template>
<!-- eslint-disable -->
  <page-layout
    :breadcrumbs="[
      {
        text: 'HOME',
        exact: true,
        to: { name: 'home' }
      },
      {
        text: 'TÉRMINOS Y CONDICIONES',
        disabled: true
      }
    ]"
  >
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          Última actualización: septiembre 30, 2019 
          <br><br>
          Lea estos Términos de uso («Términos», «Términos de uso») cuidadosamente antes de utilizar el sitio web https://viralmobilenow.com (el «Servicio») operado por Mocabi Solutions, S.L. («nosotros», «nosotros» o «nuestro «).
          <br>
          Su acceso y uso del Servicio está condicionado a su aceptación y cumplimiento de estos Términos. Estos Términos se aplican a todos los visitantes, usuarios y otras personas que acceden o utilizan el Servicio.
          <br>
          Al acceder o utilizar el Servicio, usted acepta estar sujeto a estos Términos. Si no está de acuerdo con alguna parte de los términos, no podrá acceder al Servicio.
          <br><br>
          Cuentas
          <br>
          Cuando crea una cuenta con nosotros, debe proporcionarnos información precisa, completa y actualizada en todo momento. No hacerlo constituye una violación de los Términos, lo que puede resultar en la terminación inmediata de su cuenta en nuestro Servicio.
          <br>
          Usted es responsable de salvaguardar la contraseña que utiliza para acceder al Servicio y de cualquier actividad o acción bajo su contraseña, ya sea que se encuentre en nuestro Servicio o en un servicio de un tercero.
          <br>
          Usted acepta no revelar su contraseña a ningún tercero. Debe notificarnos de inmediato al darse cuenta de cualquier violación de seguridad o uso no autorizado de su cuenta.
          <br><br>
          Propiedad intelectual
          <br>
          El Servicio y su contenido, características y funcionalidad originales son y seguirán siendo propiedad exclusiva de Mocabi solutions, S.L. y sus licenciantes.
          <br>
          Enlaces a otros sitios web
          <br>
          Nuestro Servicio puede contener enlaces a sitios web o servicios de terceros que no son propiedad ni están controlados por Mocabi solutions, S.L..
          <br>
          Mocabi Solutions, S.L. no tiene control ni asume responsabilidad por el contenido, las políticas de privacidad o las prácticas de sitios web o servicios de terceros. Además, reconoce y acepta que Mocabi solutions, S.L. no será responsable, directa o indirectamente, por cualquier daño o pérdida causada o presuntamente causada por o en relación con el uso o dependencia de dicho contenido, bienes o servicios disponibles en oa través de dichos sitios web o servicios.
          <br>
          Le recomendamos encarecidamente que lea los términos y condiciones y las políticas de privacidad de los sitios web o servicios de terceros que visite.
          <br><br>
          Terminación
          <br>
          Podemos rescindir o suspender el acceso a nuestro Servicio de inmediato, sin previo aviso o responsabilidad, por cualquier motivo, incluso sin limitación si usted incumple los Términos.
          <br>
          Todas las disposiciones de los Términos que, por su naturaleza, deberían sobrevivir a la terminación, seguirán vigentes, incluidas, entre otras, las disposiciones de propiedad, las renuncias de garantía, la indemnización y las limitaciones de responsabilidad.
          <br>
          Podemos cancelar o suspender su cuenta de inmediato, sin previo aviso o responsabilidad, por cualquier motivo, incluyendo, entre otros, si usted no cumple con los Términos.
          <br>
          Al finalizar, su derecho a utilizar el Servicio cesará inmediatamente. Si desea cancelar su cuenta, simplemente puede dejar de usar el Servicio.
          <br>
          Todas las disposiciones de los Términos que, por su naturaleza, deberían sobrevivir a la terminación, seguirán vigentes, incluidas, entre otras, las disposiciones de propiedad, las renuncias de garantía, la indemnización y las limitaciones de responsabilidad.
          <br><br>
          Renuncia
          <br>
          El uso del Servicio es bajo su propio riesgo. El Servicio se proporciona «TAL CUAL» y «SEGÚN DISPONIBILIDAD». El Servicio se proporciona sin garantías de ningún tipo, ya sean expresas o implícitas, incluidas, entre otras, las garantías implícitas de comerciabilidad, idoneidad para un propósito particular, no infracción o curso de ejecución.
          <br><br>
          Ley que rige
          <br>
          Estos Términos se regirán e interpretarán de conformidad con las leyes de España sin tener en cuenta sus disposiciones sobre conflictos de leyes.
          <br>
          Nuestro incumplimiento de cualquier derecho o disposición de estos Términos no se considerará una renuncia a esos derechos. Si alguna disposición de estos Términos se considera inválida o inaplicable por un tribunal, las disposiciones restantes de estos Términos seguirán vigentes. Estos Términos constituyen el acuerdo completo entre nosotros con respecto a nuestro Servicio, y reemplazan y reemplazan cualquier acuerdo anterior que podamos tener entre nosotros con respecto al Servicio.
          <br><br>
          Cambios
          <br>
          Nos reservamos el derecho, a nuestro exclusivo criterio, de modificar o reemplazar estos Términos en cualquier momento. Si una revisión es material, intentaremos proporcionar un aviso de al menos 30 días antes de que entren en vigencia los nuevos términos. Lo que constituye un cambio material se determinará a nuestro exclusivo criterio.
          <br>
          Al continuar accediendo o utilizando nuestro Servicio después de que esas revisiones entren en vigencia, usted acepta estar sujeto a los términos revisados. Si no está de acuerdo con los nuevos términos, deje de usar el Servicio.
          <br><br>
          Contáctenos
          <br>
          Si tiene alguna pregunta sobre estos Términos, contáctenos.
        </v-col>
      </v-row>
    </v-container>
  </page-layout>
</template>

<script>
export default {
  name: 'tyc'
}
</script>
